import { getOECode, isDisabledODEO, isOddEven, isOE, pfType999Color } from "../../constants/general";
import LoadingGif from "../../utils/LoadingGif";
import DatetimeContainer from "../date/DatetimeContainer";
import CountDownTimer from "../timer/CountDownTimer";
import { getShortBetType } from "../../utils/tickets/printUtils";
import React from "react";
import { withTranslation } from "react-i18next";
import SweetAlert from "react-bootstrap-sweetalert";
import RecentDialog from "./RecentDialog";
import { useLotto5 } from "../../store/lotto5/Lotto5Context";
import BettingDialog from "./BettingDialog";

const BettingBoard = () => {
    const lotto5 = useLotto5();
    const {
        platform, newResult, t,
        config: { lotto5Config },
        indexResultItem,
        totalResult,
        classCountDown,
        countDownTimer,
        countingSecond,
        classNameNumberDraw,
        resultItem,
        classNameLogoRender,
        platformType,
        oldResult,
        jackpot,
        winUO,
        winOE,
        winRange,
        isShowRecentBet,
        onCloseDetail,
        isShowValidateBalance,
        onCloseValidateBalance,
        onBetting,
        recentBetDetail,
        // showBonus,
        // jackpotPlus
    } = lotto5;


    const listOverUnder = isOddEven ? lotto5Config.overUnder : lotto5Config.overUnder.filter(e => !isOE(e.code));
    const getWidthItem = listOverUnder.length > 2 ? "w-25" : "w-50";
    const jp = oldResult?.jackpot;


    return <div className="col-6 no-padding-div pad-l">
        <div className="lotto5-play-right">
            <div className="row col-12 no-padding-div">
                <div className="col-5 no-padding-div lotto5-count-down">
                    <div
                        className={"loading-gif d-flex align-items-center justify-content-center loading-gif-" + platform + " " + pfType999Color}>
                        <LoadingGif />
                    </div>
                </div>
                <div className="col-7 no-padding-div header-text">
                    <div
                        className={` border-l bet-period-timer lotto5-header-${platform} ${pfType999Color} lotto5-header-draw-${platform}`}>

                        <p id="period-before">{newResult !== null ? newResult.drawLabel : t("labels:upcoming_draw")}</p>
                        <p id="timer-display"><DatetimeContainer /></p>
                    </div>
                </div>
            </div>
            <div className="row col-12 no-padding-div border-l">
                <div className="col-5 no-padding-div">
                    <CountDownTimer
                        totalResult={totalResult}
                        classCountDown={classCountDown}
                        countDownTimer={countDownTimer}
                        tenSecondCallback={countingSecond}
                        countClass="total-result-render lotto5-total-result-render " />
                    {
                        indexResultItem > 20 || indexResultItem === 0
                            ? <div className="result-time-countup-render bg-transparent" />
                            : <div
                                className="result-time-countup-render">{indexResultItem}</div>
                    }
                </div>
                <div className="col-7 no-padding-div">
                    <label
                        className="under-over block-header">{isOddEven ? t("labels:keno.underOverOddEven") : t("labels:keno.underOver")}</label>
                </div>
            </div>
            <div className="row col-12 no-padding-div">
                <div className="col-5 no-padding-div">
                    <div className="random-play">
                        <div className="blgo-random-number">
                            <div
                                className={classNameNumberDraw}>{resultItem}</div>
                            <div
                                className={classNameLogoRender + " lotto5-show-logo-render"}>
                                <img
                                    src={require(`../../assets/images/logo/${platformType}.png`)}
                                    alt="..." />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-7 no-padding-div">
                    <div className="over-under-odd-even">
                        <div className="group-play-box">
                            {
                                listOverUnder.map((item, i) => {
                                    return <div
                                        className={`box-bet box-bet-${platform}-${item.code} bet-color-${platform} ${getWidthItem}`}
                                        key={i}
                                        onClick={isDisabledODEO ? null : () => onBetting(item)}>
                                        <div id={"ou" + item.code}
                                            className="lotto5-bet">
                                            <div
                                                className={`type d-flex align-items-center justify-content-center ${item.code} OU-${item.code === winUO ? item.code : ""} OE-${item.code === winOE ? item.code : ""} bg-OU-${item.code}`}>
                                                <div>{t("labels:betPrefix.S_" + getShortBetType(item.code))}</div>
                                            </div>
                                            <div
                                                className={`d-flex justify-content-center align-items-center under-over-label-wrapper bg-range-${item.code}`}>
                                                <div>
                                                    {!isOE(item.code) ?
                                                        <p className="range-v2">{item.rangeNumber}</p> : <>
                                                            <p className="range-v2">{getOECode(item.code)}</p>
                                                        </>}
                                                    <p className="odds-v2 mt-5">{item.value}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                )
                            }

                        </div>
                    </div>
                </div>
                {/* {showBonus && <div className="bonus-reward-banner">
                    <p>រង្វាន់លួងចិត្ត</p>
                </div>} */}
            </div>
            <div className="row col-12 no-padding-div">
                <label
                    className="under-over-label block-header">{t("labels:keno.range")}</label>
            </div>
            <div className="row col-12 no-padding-div">

                <div className="over-under-odd-even range-type">
                    <div className="group-play-box">
                        {
                            lotto5Config.ranges.map((item, i) => {
                                const isActive = (jackpot === i + 1) && oldResult;
                                const isWin = item.code === winRange;
                                const showJackpot = isWin && isActive;
                                const winClass = isWin ? "win-" + item.code : "";
                                let winCl = isWin ?
                                    isActive ? "win-bg-animate" : winClass
                                    : "";

                                return <div
                                    className={"box-bet box-bet-" + platform + "-" + i + " bet-color-" + platform + " border-r" + platform}
                                    key={i}
                                    onClick={() => onBetting(item)}>
                                    <div id={"range" + item.elementId}
                                        className="lotto5-bet">
                                        <div
                                            className={`p-2 border-b ${isActive && !isWin ? "bg-win" : ""} ${winCl}`}>
                                            <p className={"type-rage " + winClass}>{item.name}</p>
                                        </div>
                                        <div
                                            className="jackpot-wrapper d-flex justify-content-center align-items-center">
                                            {showJackpot && < >
                                                <img className="jackpot-v2-img position-absolute"
                                                    src={require(`../../assets/images/jackpot/v2/${jp}.png`)}
                                                    alt="__" />
                                                <img
                                                    className="jackpot-v2-img position-absolute win-animate-border"
                                                    src={require('../../assets/images/jackpot/v2/border-jackpot.png')}
                                                    alt="___" />
                                            </>}

                                            <div>
                                                <p className="range-v2">{item.rangeNumber}</p>
                                                <p className="odds-v2">
                                                    {item.value}
                                                    {/* {jackpotPlus > 0 &&
                                                        <span className="jp-plus ml-2">+{jackpotPlus}</span>} */}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            })
                        }
                    </div>
                </div>
            </div>

            <SweetAlert
                title=""
                show={isShowRecentBet}
                onConfirm={onCloseDetail}
                confirmBtnText={t("labels:common.close")}
                showCancel={false}
                btnSize="lg">
                {
                    recentBetDetail &&
                    <RecentDialog recentBetDetail={recentBetDetail} />
                }
            </SweetAlert>

            <SweetAlert
                title="Balance"
                show={isShowValidateBalance}
                onConfirm={onCloseValidateBalance}
                confirmBtnText={t("labels:common.okay")}
                showCancel={false}
                btnSize="lg"
                confirmBtnBsStyle="warning"
            />

            <BettingDialog {...lotto5} />

        </div>
    </div>
}

export default withTranslation()(BettingBoard);